module.exports = __webpack_public_path__ + "img/thumbnail_SunBear_m_normal.9402d7f7.png";